
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlay} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";


const Start = () => {
    return ( 
        <div className="start">
            <h2>Kanchon Taboo App</h2>
           <Link to = "./window">
            <FontAwesomeIcon className = "play" icon ={faPlay} />
           </Link>
        </div>
     );
}
 
export default Start;